;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = undefined;globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "14.2.35";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/clienti/:id\",\"regex\":\"^/clienti/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/auth/reset-password\"},{\"path\":\"/booking\"},{\"path\":\"/booking/cancel\"},{\"path\":\"/booking/modify\"},{\"path\":\"/booking/modify/success\"},{\"path\":\"/booking/success\"},{\"path\":\"/calendario\"},{\"path\":\"/clienti\"},{\"path\":\"/extra\"},{\"path\":\"/login\"},{\"path\":\"/mappa\"},{\"path\":\"/ombrelloni\"},{\"path\":\"/policy\"},{\"path\":\"/prenotazioni\"}],\"isrRoutes\":[]}";import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_BUGSINK_DSN,

  // Cattura tutti gli errori
  tracesSampleRate: 1.0,

  // Non mandare nulla se la DSN non è configurata
  enabled: process.env.NODE_ENV === 'production' && !!process.env.NEXT_PUBLIC_BUGSINK_DSN,

  // Ignora errori di rete prevedibili (utente offline, ecc.)
  ignoreErrors: [
    'Network request failed',
    'NetworkError',
    'Failed to fetch',
    'Load failed',
  ],
})
